<template>
  <div class="page-wrap">
    <Header></Header>
    <retrieve-password ref="retrieveRef"></retrieve-password>
    <Bottom></Bottom>
  </div>
</template>
<script>
import RetrievePassword from "./components/RetrievePassword.vue";
import Bottom from "@/components/Bottom.vue";
import Header from "@/components/Header.vue";
export default {
  components: { RetrievePassword, Bottom, Header },
  data() {
    return {};
  },

  methods: {}
};
</script>
<style lang="less" scoped>
</style>
